var map = {
	"./de.json": [
		47358,
		7358
	],
	"./en.json": [
		33029,
		3029
	],
	"./es.json": [
		72166,
		2166
	],
	"./fr.json": [
		10475,
		475
	],
	"./it.json": [
		57672,
		7672
	],
	"./ja.json": [
		1721,
		1721
	],
	"./ko.json": [
		38620,
		8620
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 37845;
module.exports = webpackAsyncContext;